import useSWRImmutable from 'swr/immutable';
import { logger } from '@belong/logging';
import { ICatalogOfferReward, IOfferTemplate } from '@belong/types';
import { IAppliedOfferReward } from '@belong/types/api/offers';
import { getContentfulSettings, getEntries, isErrorResponse } from '@belong/contentful';
import { getCorrelationId } from '@belong/user';
import { getRewardTemplateName, OFFER_TEMPLATE_TYPE } from '../templates';
import { FOfferTemplate } from '../factories/OfferTemplate.factory';

interface IUseOfferTemplate {
  isLoading: boolean;
  error?: Error;
  template?: IOfferTemplate;
}

const loadTemplate = async (templateName: string): Promise<IOfferTemplate | undefined> => {
  const query = {
    content_type: 'offerTemplate',
    'fields.code': templateName
  };

  const result = await getEntries(query, getContentfulSettings(), getCorrelationId());
  if (isErrorResponse(result) || !result.length) {
    throw new Error(`Failed to load template '${templateName}'`);
  }

  return FOfferTemplate(result[0]);
};

// Resolve template CODE from reward and load appropriate template from the CMS
// Note: Using SWRImmutable to prevent re-fetching/revalidation on tab change or focus
export const useOfferTemplate = (
  reward: ICatalogOfferReward | IAppliedOfferReward,
  templateType: OFFER_TEMPLATE_TYPE
): IUseOfferTemplate => {
  const templateName = getRewardTemplateName(reward, templateType);
  const { isLoading, error, data: template } = useSWRImmutable(templateName, () => loadTemplate(templateName));

  if (error) {
    logger.error('[useOfferTemplate]', error);
  }

  return {
    isLoading,
    error,
    template
  };
};
